import React from 'react';
import {Appointment} from "../models/Appointment";
import {TagBox} from "./TagBox";
import {getShortenDateWithDayOfWeek} from "../utils/Utils";
import TimeType from "../models/TimeType";

export interface PollRangeTagBoxProp {
    appointment: Appointment,
}

const PollRangeTagBox = ({ appointment }: PollRangeTagBoxProp) => {
    const firstDate = appointment.getPollDateFirstDate();
    const lastDate = appointment.getPollDateLastDate();
    const timeType = appointment.pollItems[0].timeType; // 모든 pollItem의 시간대는 동일하다고 가정
    const timeTypeString = TimeType.getTimeTypeStringForTag(timeType);

    const text = `${getShortenDateWithDayOfWeek(firstDate)} - ${getShortenDateWithDayOfWeek(lastDate)} ${timeTypeString}`

    return (<TagBox text={text} />)
}

export default PollRangeTagBox;